import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

const chainIdToIconMapper = {
  3: 'ethereum-icon',
  1: 'ethereum-icon',
  97: 'bsc-icon',
  56: 'bsc-icon',
};

export default function NetworkIcon({ chainId }) {
  const iconName = chainIdToIconMapper?.[chainId];
  return <Icon name={iconName} />;
}

NetworkIcon.defaultProps = {
  chainId: window.chainId,
};

NetworkIcon.propTypes = {
  chainId: PropTypes.number,
};
